/* istanbul ignore next */
export default function init({firstName, id, lastName}) {
    const appId =
        import.meta.env.HAL_ENVIRONMENT === 'production' ?
            'vooa3i04'
        :   'fq68z83s';
    const w = window;
    const ic = w.Intercom;

    window.intercomSettings = {
        app_id: appId,
        name: firstName + ' ' + lastName,
        user_id: id,
    };

    if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
    } else {
        const d = document;
        const i = () => {
            i.c(arguments);
        };

        i.q = [];
        i.c = args => {
            i.q.push(args);
        };
        w.Intercom = i;

        const l = () => {
            const s = d.createElement('script');
            const x = d.getElementsByTagName('script')[0];

            s.type = 'text/javascript';
            s.async = true;
            s.src = `https://widget.intercom.io/widget/${appId}`;

            x.parentNode.insertBefore(s, x);
        };

        if (document.readyState === 'complete') {
            l();
        } else if (w.attachEvent) {
            w.attachEvent('onload', l);
        } else {
            w.addEventListener('load', l, false);
        }
    }
}
